import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { UPLOAD_CBCT } from './task-name'

export default createUIDefinition({
    taskName: UPLOAD_CBCT,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.CBCT_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-3dscan/upload-cbct.js